<!-- 新增计费方式弹窗 -->
<template>
  <dialogBody @confirm="confirm" @cancel="cancel" ref="body">
    <template slot="title">
      {{title}}
    </template>
    <div v-show="chargeType == 'single'">
      <div class="formContainer">
        <label><span class="required">*</span>计费名称</label>
        <input class="textInput" type="text" v-model.trim="chargeName" maxlength="20" placeholder="请输入名称" />
      </div>
      <!-- <div class="formContainer">
        <label><span class="required">*</span>计费价格</label>
        <input class="textInput" type="number" v-model="price" @keydown="keydownFloat($event)" />
      </div> -->
      <div class="formContainer">
        <label><span class="required">*</span>日期</label>
        <el-date-picker v-model="value2" type="month" placeholder="选择月">
        </el-date-picker>
      </div>
    </div>
  </dialogBody>
</template>

<script>
  import dialogBody from '@/components/module/dialog/dialogBody.vue'
  export default {
    components: {
      dialogBody
    },

    data () {
      return {
        unitId: '',
        value2: '',
        title: '',
        callback: undefined,
        chargeType: 'single',
        stairNumOne: 0,
        stairNumTwo: 0,
        pkid: '',
        chargeName: '',
        price: 0,
        priceOne: 0,
        priceTwo: 0,
        priceThree: 0,
        nowChargeMode: {},
        activeName: ''
      }
    },
    computed: {
      canSave () {
        if(this.chargeName=='') {
          this.$dialogMethod.showMessage('请输入计费名称')
          return false
        }
        if(this.chargeType=='single') {
          // if(isNaN(parseFloat(this.price))) {
          //   this.$dialogMethod.showMessage('请输入格式正确的价格')
          //   return false
          // } else if(parseFloat(this.price)<=0) {
          //   this.$dialogMethod.showMessage('计费价格不能设置为0')
          //   return false
          // }
          if(!this.value2) {
            this.$dialogMethod.showMessage('请选择日期')
            return false
          }
        } else if(this.chargeType=='step') {
          if(isNaN(parseFloat(this.priceOne))||isNaN(parseFloat(this.priceTwo))||isNaN(parseFloat(this.priceThree))) {
            this.$dialogMethod.showMessage('请输入格式正确的价格')
            return false
          } else if(parseInt(this.stairNumOne)>=parseInt(this.stairNumTwo)) {
            this.$dialogMethod.showMessage('请输入合理的阶梯区间')
            return false
          }
        }
        return true
      }
    },

    methods: {

      confirm () {
        if(!this.canSave) {
          return
        }
        if(this.callback!=undefined) {
          var result={
            pkid: this.pkid,
            name: this.chargeName,
            billingMode: 'SingleBilling',
            year: (this.value2.getFullYear()).toString(),
            month: (this.value2.getMonth()+1).toString(),
            unitId: this.unitId,
            deductionStandard: this.price.toString()
          }
          this.callback(result)
        }
        this.close()
      },
      cancel () {
        this.close()
      },
      close () {
        this.pkid=''
        this.chargeName=''
        this.price=0
        this.priceOne=0
        this.priceTwo=0
        this.priceThree=0
        this.stairNumOne=0
        this.stairNumTwo=0
        this.$refs.body.hide()
      },
      open (title,type,activeName,nowInfos,callback) {
        this.title=title
        this.chargeType=type
        this.callback=callback
        this.activeName=activeName
        if(!isempty(nowInfos)) {
          this.nowChargeMode=nowInfos
          this.price=parseFloat(nowInfos.deductionStandard);
          this.unitId=nowInfos.unitId;
          this.chargeName=nowInfos.name
          this.value2=new Date(nowInfos.year+'-'+nowInfos.month)
          this.pkid=nowInfos.id
        }
        this.$refs.body.open()
      },
      keydownFloat (ev) {
        if(ev.keyCode==109||ev.keyCode==229) {
          ev.preventDefault()
        }
      },
      keydownInt (ev) {
        if(ev.keyCode==109||ev.keyCode==229||ev.keyCode==110||ev.keyCode==190) {
          ev.preventDefault()
        }
      },

    }
  }
</script>
<style scoped>
  .formContainer {
    margin-bottom: 12px;
  }

  .formContainer>label {
    min-width: 72px;
    text-align: right;
    display: inline-block;
    margin-right: 12px;
    line-height: 32px;
  }

  .formContainer>label>span {
    display: inline-block;
    width: 8px;
  }

  .littleLine {
    color: #CDCDCD;
    margin: 0 6px;
  }

  .formContainer>span:nth-of-type(2) {
    margin-left: 6px;
  }

  .formContainer>span:nth-of-type(4) {
    margin-left: 6px;
  }

  .devideLine {
    display: inline-block;
    width: 1px;
    height: 32px;
    background-color: #CDCDCD;
    vertical-align: top;
    margin: 0 10px;
  }

  .required {
    color: red;
  }

  .devideBar {
    background-color: #F2F2F2;
    height: 6px;
    margin-bottom: 12px;
  }

  .textInput {
    width: 370px;
  }

  .numInput {
    width: 60px;
  }

  .overText {
    display: inline-block;
    width: 80px;
    margin-left: 20px;
  }
</style>